/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardDto
 */
export interface DashboardDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardDto
     */
    config?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardDto
     */
    users?: Array<string> | null;
}

export function DashboardDtoFromJSON(json: any): DashboardDto {
    return DashboardDtoFromJSONTyped(json, false);
}

export function DashboardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'config': !exists(json, 'config') ? undefined : json['config'],
        'users': !exists(json, 'users') ? undefined : json['users'],
    };
}

export function DashboardDtoToJSON(value?: DashboardDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'config': value.config,
        'users': value.users,
    };
}


